module Meevo.Plugins.DrawerManager {
    "use strict";

    export class DrawerManagerSectionBase {

        public selectedDrawer: Meevo.Model.Drawer;

        constructor(public sectionType: Meevo.Plugins.DrawerManager.DrawerManagerSectionTypeEnum,
            public context: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            public template: string,
            public personalHeader:boolean,
            public personalFooter:boolean) {
        }

        initialize(...args: any[]) {
        }

        reset(preventDataFetch: boolean = false) {
            if (this.context.selectedDrawer) {
                this.selectedDrawer = _.findWhere(this.context.allDrawers, { id: this.context.selectedDrawer.id });
            }
        }

        // the user picked a drawer from a section's drawer dropdown
        onDrawerPicked() {
            this.context.setSelectedDrawer(this.selectedDrawer, true, Meevo.Model.DrawerSelectionReasonEnum.ManualChange);
        }

        getSectionName() {
            return this.context.selectedDrawer.displayName;
        }

        getState(): any {
            return null;
        }

        setState(state: any) {
        }
    }
}